import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import { state, ui } from '../../../interfaces/interfaces';
import JobsDrawer from './MainForm/RightPanel';
import { Container, Divider, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import FormPanel from './MainForm';
import LeftPanel from './MainForm/LeftPanel';
import useDebugInformation from '../../../hooks/useDebugInformation';
import ChargesSideBar from '../../Shared/ChargesSideBar';
import CarePlanSideBar from '../../Shared/CarePlanSideBar';
import Paper from '@mui/material/Paper';
import Snackbar from '../../Shared/Snackbar';
import { SnackbarProvider } from 'notistack';
import bookingCycleMgr from '../../../services/bookingCycleMgr';
import job from '../../../utilities/objects/job';
import JobSearchModal from './JobSearchModal';
import JobHistoryModal from './MainForm/Steps/StepOne/ProblemDetails/JobCoverage/JobHistoryModal';
import bookingFormLoader from '../../../services/bookingFormLoader';
import { useBeforeunload } from 'react-beforeunload';
import { useAppSelector } from "@store/hooks";
import CallsPanel from './MainForm/LeftPanel/CallsPanel';
import CADENTModal from '../../Shared/CADENTModal';
import { AuthContext } from '../../../utilities/authProvider';

const name = "BookingForm"

type Props = {
  parent: string
}

const saveBookingMgr = async (e: Event) => {
  e.preventDefault();
  bookingCycleMgr.setCurrentBookingUnloaded();
  bookingCycleMgr.save();
  // await job.saveIndexedDBOnExit("Page: BookingForm, Action: saveBookingMgr, Message: Booking saved, Reason: Page refresh, Booking: " + job.jobId);
  await job.saveIndexedDBOnExit({ page: "BookingForm", action: "saveBookingMgr", message: "Booking saved", reason: "Page refresh/close", booking: state.JobId });
  return "Page will be reloaded in 5 seconds";
};

const BookingForm: React.FC<Props> = ({ parent }) => {
  const { isAuthenticated } = React.useContext(AuthContext);
  const done = useAppSelector(({ ui }) => ui.Done)
  const comboAgent = useAppSelector(({ ui }) => ui.ComboAgent)
  const devFrom = useAppSelector(({ ui }) => ui.DevFrom)
  const destinationNumber = useAppSelector(({ temp }) => temp.DestinationNumber)
  const jobHistoryModal = useAppSelector(({ ui }) => ui.JobHistoryModal)
  const cacheLoading = useAppSelector(state => state.state.CacheLoading);
  const activeStep = useAppSelector(({ ui }) => ui.ActiveStep)
  const [value, setValue] = React.useState('');

  const load = React.useCallback((signal: AbortSignal) => {
    // isTriggered.current = true
    isAuthenticated && bookingFormLoader(signal);
  }, [isAuthenticated]);

  React.useEffect(() => {
    const controller = new AbortController();
    load(controller.signal);
    return () => controller.abort();
  }, [load]);

  React.useEffect(() => {
    if (devFrom && devFrom.startsWith("07")) ui.PropertyContactMobile = devFrom
    if (devFrom && !devFrom.startsWith("07")) ui.PropertyContactLandline = devFrom
  }, [devFrom])

  useBeforeunload(saveBookingMgr);

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { done, comboAgent, devFrom, destinationNumber })

  return (
    isAuthenticated ? <Container maxWidth="md">
      <input onChange={(event) => setValue(event.target.value)} value={value} hidden={true} />
      <CssBaseline />
      {/* <Cache /> */}
      <SnackbarProvider maxSnack={3}>
        <Snackbar parent={debugName} />
        {!cacheLoading && <Box sx={(theme) => ({
          width: 'auto',
          margin: 'auto',
          maxWidth: 640,
          [theme.breakpoints.up(600 + Number(theme.spacing(2)) * 2)]: {
            width: 600,
            margin: 'auto',
            // minWidth: 310
          },
          minWidth: 365,
        })}>
          {/* display form only when all caching is done */}
          {done && <Box id="main-container" style={{ display: "grid", gridTemplateColumns: '1fr 5fr 1fr', justifyContent: "center", columnGap: "10px", alignContent: "center", alignItems: "start" }}>
            <Stack divider={<Divider orientation="horizontal" flexItem />}
              spacing={2}>
              <Paper elevation={4}><LeftPanel parent={debugName} /></Paper>
              <ChargesSideBar parent={debugName} />
              {activeStep === 0 && <CallsPanel />}
              <CarePlanSideBar parent={debugName} />
            </Stack>
            <FormPanel parent={debugName} />
            <JobSearchModal parent={debugName} />
            <JobsDrawer />
            <CADENTModal />
            {jobHistoryModal && <JobHistoryModal parent={debugName} />}
          </Box>}
        </Box>}
      </SnackbarProvider>
    </Container >
      : <div>Loading...</div>
  );
}

export default React.memo(BookingForm)
